import { render, staticRenderFns } from "./gotop.vue?vue&type=template&id=6c198e5e&"
import script from "./gotop.vue?vue&type=script&lang=js&"
export * from "./gotop.vue?vue&type=script&lang=js&"
import style0 from "./gotop.vue?vue&type=style&index=0&id=6c198e5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports